import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly LANGUAGE_KEY: string = 'app_language';
  private readonly DEFAULT_LANGUAGE: string = 'es';
  
  private translateService: TranslateService = inject(TranslateService);
  private primeng: PrimeNG = inject(PrimeNG);

  /**
   * Inicializa el idioma de la aplicación
   * Primero intenta cargar desde localStorage, si no existe usa el idioma por defecto
   */
  initializeLanguage(): void {
    const savedLanguage: string | null = this.getSavedLanguage();
    const languageToUse: string = savedLanguage || this.DEFAULT_LANGUAGE;
    
    this.translateService.setDefaultLang(this.DEFAULT_LANGUAGE);
    this.setLanguage(languageToUse);
  }

  /**
   * Cambia el idioma de la aplicación y guarda en localStorage
   */
  setLanguage(lang: string): void {
    this.translateService.use(lang);
    this.saveLanguage(lang);
    
    // Actualizar traducciones de PrimeNG
    this.translateService.get('primeng').subscribe(res => {
      this.primeng.setTranslation(res);
    });
  }

  /**
   * Obtiene el idioma actual
   */
  getCurrentLanguage(): string {
    return this.translateService.currentLang || this.getSavedLanguage() || this.DEFAULT_LANGUAGE;
  }

  /**
   * Guarda el idioma en localStorage
   */
  private saveLanguage(lang: string): void {
    try {
      localStorage.setItem(this.LANGUAGE_KEY, lang);
    } catch (error) {
      console.error('Error al guardar idioma en localStorage:', error);
    }
  }

  /**
   * Obtiene el idioma guardado en localStorage
   */
  private getSavedLanguage(): string | null {
    try {
      return localStorage.getItem(this.LANGUAGE_KEY);
    } catch (error) {
      console.error('Error al leer idioma de localStorage:', error);
      return null;
    }
  }
}

